/* Grilla de colecciones: flechas + rotacion de portadas.

   El scroll con el dedo lo hace el navegador (overflow-x + scroll-snap en el CSS), aca solo
   esta lo que el CSS no puede: mover con las flechas, apagarlas en las puntas, y cruzar las
   portadas apiladas de cada tarjeta.

   Diferencias a proposito con el original:
   - Todo va acotado a cada seccion. El original busca por id fijo (bohColWrap) y por
     .boh-colgrid__prev global: con la seccion puesta dos veces, la segunda no anda y las
     flechas de la primera mueven la fila equivocada.
   - UN SOLO intervalo por seccion en vez de uno por tarjeta. En cada tic avanza una sola
     tarjeta y va rotando cual: cada tarjeta termina cambiando cada `periodo` y los cambios
     quedan repartidos en el tiempo, que es el desfasaje que el original consigue con seis
     setTimeout + seis setInterval.
   - El intervalo se PARA fuera de pantalla y con la pestana oculta, y se limpia cuando el
     editor de temas vuelve a renderizar la seccion. El original no limpia nada: editando,
     los timers se acumulan y las portadas parpadean cada vez mas rapido. */
(() => {
  const REDUCIDO = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Cada seccion viva deja aca su forma de apagarse, para poder limpiarla cuando el nodo
     desaparece del DOM (editor de temas). */
  const vivas = new Set();

  const limpiarMuertas = () => {
    for (const s of vivas) {
      if (!s.nodo.isConnected) {
        s.apagar();
        vivas.delete(s);
      }
    }
  };

  const iniciar = (seccion) => {
    if (seccion.dataset.fpListo === '1') return;
    seccion.dataset.fpListo = '1';

    const ventana = seccion.querySelector('.fp-colgrid__viewport');
    if (!ventana) return;

    const prev = seccion.querySelector('.fp-colgrid__prev');
    const next = seccion.querySelector('.fp-colgrid__next');
    const tarjetas = [...seccion.querySelectorAll('.fp-colgrid__item')];

    /* ---------- flechas ---------- */

    const paso = () => {
      const t = tarjetas[0];
      return t ? t.getBoundingClientRect().width : ventana.clientWidth * 0.6;
    };

    const mover = (dir) => {
      ventana.scrollBy({ left: dir * paso(), behavior: REDUCIDO ? 'auto' : 'smooth' });
    };

    const estado = () => {
      const max = ventana.scrollWidth - ventana.clientWidth;
      // Si entra todo, no hay nada que scrollear: las flechas sobran.
      seccion.classList.toggle('fp-colgrid--estatico', max <= 4);
      if (prev) prev.classList.toggle('is-off', ventana.scrollLeft <= 4);
      if (next) next.classList.toggle('is-off', ventana.scrollLeft >= max - 4);
    };

    if (prev) prev.addEventListener('click', () => mover(-1));
    if (next) next.addEventListener('click', () => mover(1));

    let pedido = 0;
    ventana.addEventListener(
      'scroll',
      () => {
        cancelAnimationFrame(pedido);
        pedido = requestAnimationFrame(estado);
      },
      { passive: true }
    );
    window.addEventListener('resize', estado);
    estado();
    // Recien con las fotos cargadas el scrollWidth es el definitivo.
    if (document.readyState !== 'complete') window.addEventListener('load', estado, { once: true });

    /* ---------- rotacion de portadas ---------- */

    const rotan = tarjetas
      .map((t) => [...t.querySelectorAll('.fp-colgrid__image')])
      .filter((fotos) => fotos.length > 1)
      .map((fotos) => ({ fotos, actual: 0 }));

    if (seccion.dataset.fpRotar !== 'true' || REDUCIDO || rotan.length === 0) return;

    const periodo = Number(seccion.dataset.fpIntervalo) || 700;
    // Repartir el periodo entre las tarjetas es lo que evita que las 6 cambien en el mismo
    // frame y se vea como un parpadeo del bloque entero.
    const tic = Math.max(120, Math.round(periodo / rotan.length));

    let turno = 0;
    let reloj = null;
    let aLaVista = true;

    const avanzar = () => {
      const t = rotan[turno % rotan.length];
      turno += 1;
      const siguiente = (t.actual + 1) % t.fotos.length;
      t.fotos[t.actual].classList.remove('is-active');
      t.fotos[siguiente].classList.add('is-active');
      t.actual = siguiente;
    };

    const arrancar = () => {
      if (reloj || !aLaVista || document.hidden) return;
      reloj = setInterval(avanzar, tic);
    };

    const parar = () => {
      if (!reloj) return;
      clearInterval(reloj);
      reloj = null;
    };

    let mirilla = null;
    if ('IntersectionObserver' in window) {
      mirilla = new IntersectionObserver(
        (entradas) => {
          aLaVista = entradas[0].isIntersecting;
          aLaVista ? arrancar() : parar();
        },
        { threshold: 0 }
      );
      mirilla.observe(seccion);
    } else {
      arrancar();
    }

    const alCambiarPestana = () => (document.hidden ? parar() : arrancar());
    document.addEventListener('visibilitychange', alCambiarPestana);

    vivas.add({
      nodo: seccion,
      apagar: () => {
        parar();
        if (mirilla) mirilla.disconnect();
        document.removeEventListener('visibilitychange', alCambiarPestana);
        window.removeEventListener('resize', estado);
      },
    });
  };

  const iniciarTodo = (raiz) => {
    const ambito = raiz && raiz.querySelectorAll ? raiz : document;
    ambito.querySelectorAll('.fp-colgrid').forEach(iniciar);
  };

  iniciarTodo(document);

  // Editor de temas: al agregar, sacar o reordenar una coleccion, la seccion se re-renderiza.
  document.addEventListener('shopify:section:load', (e) => {
    limpiarMuertas();
    iniciarTodo(e.target);
  });
  document.addEventListener('shopify:section:unload', limpiarMuertas);
})();
